import script from "./Holdings.vue?vue&type=script&setup=true&lang=js"
export * from "./Holdings.vue?vue&type=script&setup=true&lang=js"

import "./Holdings.vue?vue&type=style&index=0&id=1523f271&scoped=true&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1523f271"]])

export default __exports__